<template>
    <cell>
        {{ label }}
    </cell>
</template>

<script>
import Cell from '@/Components/Storemanager/InitialColumn/Cell';

export default {
    components: {Cell},

    props: {
        label: String,
    },
};
</script>
